export enum actionTypes {
    PROMOTIONS_CONFIGURATION_PROMOTIONS_FEED_ADD = 'PROMOTIONS_CONFIGURATION:PROMOTIONS_FEED:ADD',
    PROMOTIONS_CONFIGURATION_UPDATE = 'PROMOTIONS_CONFIGURATION:UPDATE'
}
